module.exports = __webpack_public_path__ + "img/male_resultD.717bf23a.png";